import { useEffect } from 'react';

/**
 * Locks the `<body>` scroll when the component mounts and restores it on unmount.
 * Handles nested usage by reference counting via data attributes.
 */
const useLockBodyScroll = () => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const { body } = document;
    if (!body) {
      return undefined;
    }

    const currentCount = Number(body.dataset.lockScrollCount || 0);
    if (currentCount === 0) {
      body.dataset.originalOverflow = body.style.overflow || '';
      body.style.overflow = 'hidden';
    }

    body.dataset.lockScrollCount = String(currentCount + 1);

    return () => {
      const count = Number(body.dataset.lockScrollCount || 1);
      const nextCount = Math.max(0, count - 1);

      if (nextCount === 0) {
        const originalOverflow = body.dataset.originalOverflow || '';

        if (originalOverflow) {
          body.style.overflow = originalOverflow;
        } else {
          body.style.removeProperty('overflow');
        }

        delete body.dataset.lockScrollCount;
        delete body.dataset.originalOverflow;
      } else {
        body.dataset.lockScrollCount = String(nextCount);
      }
    };
  }, []);
};

export default useLockBodyScroll;
